const LocationPin = props => (
  <svg width="25" height="35" viewBox="0 0 25 35" fill="#1E88E5" {...props}>
    <path d="M12.5 0C5.58929 0 0 5.4775 0 12.25C0 21.4375 12.5 35 12.5 35C12.5 35 25 21.4375 25 12.25C25 5.4775 19.4107 0 12.5 0ZM12.5 16.625C10.0357 16.625 8.03571 14.665 8.03571 12.25C8.03571 9.835 10.0357 7.875 12.5 7.875C14.9643 7.875 16.9643 9.835 16.9643 12.25C16.9643 14.665 14.9643 16.625 12.5 16.625Z" />
  </svg>
);

export default LocationPin;
